<template>
  <div>
    <div class="trees">
      <div class="radios" v-show="agents">
        <span class="title_cc">下级代理</span>
        <el-radio-group v-model="radio9" size="small" @change="checkTypechange">
          <el-radio label="0" border>单选</el-radio>
          <el-radio label="1" border>全选</el-radio>
        </el-radio-group>
      </div>

      <el-input placeholder="输入代理名称进行过滤" v-model="filterText" v-show="agents">
      </el-input>

      <el-tree class="filter-tree" :data="agentTreeData" :props="defaultProps" show-checkbox :check-strictly="checkTypes" node-key="AgentCode" default-expand-all :filter-node-method="filterNode" ref="tree2" @check="getCheckedNodes" :default-checked-keys="agentTreeDataS" v-show="agents">
      </el-tree>
    </div>
    <el-tabs v-model="activeName" @tab-click="handleClick" style="height:100%;" >
      <el-tab-pane label="资金" name="capital">
      </el-tab-pane>
      <el-tab-pane label="持仓" name="position">
      </el-tab-pane>
      <el-tab-pane label="委托" name="mydelegation">
      </el-tab-pane>
      <el-tab-pane label="成交" name="mydealDetail">
      </el-tab-pane>
      <el-tab-pane label="单量统计" name="order">
      </el-tab-pane>
      <!-- <el-tab-pane label="盈亏统计" name="profit">
      </el-tab-pane> -->
      <el-tab-pane label="出入金统计" name="withCharge">
      </el-tab-pane>
      <el-tab-pane label="出入金明细" name="withdrawalDetail">
      </el-tab-pane>
      <div class="derive" v-show="isderive" style="position: fixed; top: 60px;">
          <button type="submit" class="btn btn-primary" @click="ExportAll()" style="float:right;font-size:12px;color:#fff;margin-right:5px;">
            <a id="Exportlink" href=""  ref="test" download="w3logo"></a>
            <i class="fa fa-download  "></i> 导出</button>
      </div>
      <div style="height:100%;"  :is="currenTab" :agentID="agentTreeDataS" @esd="expended" @positionkey='positionkeyvalue' @mydelegation='mydelegationvalue' @mydealDetail='mydealDetailvalue' @order='ordervalue' @withCharge='withChargevalue' @withdrawalDetail='withdrawalDetailvalue'></div>

    </el-tabs>
      <!-- <div>
          <div>
              <p>是否导出全部数据？</p>
              <p>
                  <a type="button" href="" class="btn btn-info ExportAlls" @click="closeDelMask()">确定</a>
                  <button type="button" class="btn btn-default btn-q btn-q-del" @click="closeDelMask()">取消</button>
              </p>            
          </div>

      </div>     -->
      <div class="del-mask">
          <div class="mask_box">
              <div class="panel panel-default  no-border">
                <!-- Default panel contents -->
                <div class="panel-heading">导出所有</div>
                <div class="panel-body">
                  <form class="form-inline form-inline1" novalidate="" role="form">
                    <div>
                      <div class="error3">
                        <div class="messageinfo"></div>
                      </div>
                    </div>
                  </form>
                </div>
                <div class="closed closed-del" @click="closeDelMask()">×</div>
                <!-- Table -->
                <p>
                  <span class="fr">
                    <button type="button"  class="btn btn-info ExportAlls" style="color:#fff !important;" @click="closeDelMask1()">跳转到导出页面</button>
                  </span>
                  <span class="fr">
                    <button type="button" class="btn btn-default btn-q btn-q-del" @click="closeDelMask()">取消</button>
                  </span>
                </p>
              </div>
          </div>
        </div>
  </div>

</template>

<script>
import mydealDetail from "./mydealDetail/mydealDetailS.vue"; // 成交
import mydelegation from "./mydelegation/mydelegationDetailS.vue"; // 委托
import capital from "./mycapital/mycapitalS.vue"; // 资金
import position from "./position/positionDetailS.vue"; // 持仓
import order from "./staticsToday/StatisticsOrder/StatisticsOrderS.vue"; // 单量统计
import profit from "./staticsToday/StatisticsProfit/StatisticsProfitS.vue";
import withCharge from "./staticsToday/StatisticsWithCharge/StatisticsWithChargeS.vue"; // 出入金统计
import withdrawalDetail from "./staticsToday/withdrawalDetail/withdrawalDetailS.vue"; // 出入金明细
export default {
  // 当日查询
  name: "todayreports",
  components: {
    mydealDetail, //成交明细
    mydelegation, //委托
    capital, // 资金
    position, //持仓
    order, // 单量统计
    profit, // 资金
    withCharge, // 出入金统计
    withdrawalDetail, //出入金明细
  },
  data() {
    if (!sessionStorage.getItem("tabname")) {
      sessionStorage.setItem("tabname", "capital");
    }
    return {
      // activeName: sessionStorage.getItem("tabname"),
      // currenTab: sessionStorage.getItem("tabname"),
      activeName: "capital",
      currenTab: "capital",
      filterText: "",
      agentTreeData: [
        {
          AgentCode: JSON.parse(sessionStorage.getItem("userInfo")).UserCode,
          AgentName: JSON.parse(sessionStorage.getItem("userInfo")).UserName,
          Childs: [],
          Level: 0,
          Parent: {}
        }
      ],
      agenttrees: [], //获取经纪人树
      //树形结构
      defaultProps: {
        id: "AgentCode",
        children: "Childs",
        label: "AgentName"
      },

      expandedKeys: [], //全局筛选后默认打开的节点

      agentTreeDataS: [JSON.parse(sessionStorage.getItem("userInfo")).UserCode],
      radio9: "1",
      agents: true,
      checkTypes: false,
      tabname:"capital",
      AgentIds:[],
      UserKey:"",
      isderive:false,
      ordervalueobj:{},
      withChargevalueobj:{},
      withdrawalDetailvalueobj: {}
    };
  },
  watch: {
    filterText(val) {
      this.$refs.tree2.filter(val);
    },
    tabname(val){
      if(this.tabname == "capital"){
          this.isderive = false
      }else{
          this.isderive = true;
      }
    }
  },
  created() {
    this.$store.state.loaction = "/selects/todayreports";
    if(this.tabname == "capital"){
          this.isderive = false;
      }else{
          this.isderive = true;
      }
  },
  mounted() {
    this.viewAgetnTree();
  },
  methods: {
    handleClick(tab, event) {
      this.tabname = tab.name;
      this.currenTab = tab.name;
      sessionStorage.setItem("tabname", tab.name);
      if(this.tabname == "capital"){
          this.isderive = false
      }else{
          this.isderive = true;
      }
    },
    checkTypechange(v) {
      if (v == 0) {
        this.checkTypes = true;
      } else {
        this.checkTypes = false;
      }
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.AgentName.indexOf(value) !== -1;
    },
    //    获取经纪人树
    viewAgetnTree() {
      this.loading = true;
      this.$loginapi.post("/subagent/QueryAgentTree", null, e => {
        this.loading = false;
        if (e.Ret == 0) {
          // this.agenttrees = e.Data.Agents;
          this.agentTreeData[0].Childs = e.Data.Agents;
          if (e.Data.Agents != []) {
            // console.log(this.$store.state.userInfo);
            // this.agentTreeData[0].AgentCode = e.Data.Agents[0].Parent.AgentCode;
            // this.agentTreeData[0].AgentName = e.Data.Agents[0].Parent.AgentName;
          }

          if (e.Data.Agents.length > 0) {
            // if (this.toSelectCode != "") {
            //   this.getAllInfo(this.toSelectCode);
            //   setTimeout(this.selectTreeNode, 200);
            // } else {
            //   this.getAllInfo(e.Data.Agents[0].AgentCode);
            //   setTimeout(this.selectTreeNode, 200);
            // }
          }
        }
      });
    },
    getCheckedNodes(leafOnly, includeHalfChecked) {
      let temagentArray = this.$refs.tree2.getCheckedNodes();
      let agentArray = [];
      temagentArray.forEach(element => {
        agentArray.push(element.AgentCode);
      });
      this.agentTreeDataS = agentArray;
    },
    expended(val) {
      this.$store.state.agentstate = val;
      if (val != "AllAgent") {
        $(".trees").animate({ width: "0px" });
        this.agents = false;
      } else {
        $(".trees").animate({ width: "195px" });
        this.agents = true;
      }
      this.viewAgetnTree();
    },
    // 持仓传值关键字
    positionkeyvalue(val){
      this.UserKey = val;
    },
    //委托传值关键字
    mydelegationvalue(val){
      this.UserKey = val;
    },
    //成交传值关键字
    mydealDetailvalue(val){
      this.UserKey = val;
    },
    //单量统计传值
    ordervalue(val){
      this.ordervalueobj = val;
    },
    //出入金统计传值
    withChargevalue(val){
      this.withChargevalueobj = val;
    },
    //出入金明细传值
    withdrawalDetailvalue(val){
      this.withdrawalDetailvalueobj = val;
    },
        // 导出
    ExportAll() {
              let url = "";
              let postData = {};
              if(this.tabname == "position"){   //持仓
                url = "mycustomer/ExportUserCurrentPosition"
                postData = {
                  AgentIds:this.agentTreeDataS,
                  UserKey:this.UserKey
                }
              }else if(this.tabname == "mydelegation"){  //委托
                url = "mycustomer/ExportUserCurrentOrder"
                postData = {
                  AgentIds:this.agentTreeDataS,
                  UserKey:this.UserKey
                }
              }else if(this.tabname == "mydealDetail"){ //成交
                url = "mycustomer/ExportUserCurrentTrade"
                postData = {
                  AgentIds:this.agentTreeDataS,
                  UserKey:this.UserKey
                }
              }else if(this.tabname == "order"){  //单量统计
                url = "mycustomer/ExportAgentCurrentTradeVolume"
                postData = {
                  AgentIds:this.agentTreeDataS,
                  UserKey:this.UserKey,
                  SortType:this.ordervalueobj.SortType,
                  Commodity:this.ordervalueobj.Commodity,
                  PositionEffect:this.ordervalueobj.PositionEffect
                }
              }else if(this.tabname == "withCharge"){   //出入金统计
                url = "mycustomer/ExportAgentUserCurrentMoneyTransferStatistical"
                postData = {
                  AgentIds:this.agentTreeDataS,
                  UserKey:this.UserKey,
                  MoneyTransType:this.withChargevalueobj.MoneyTransType,
                  SortType:this.withChargevalueobj.SortType,
                  State:this.withChargevalueobj.State
                }                
              } else if(this.tabname == "withdrawalDetail"){  //出入金明细
                url = "report/ExportAgentUserHistoryMoneyTransfer"
                postData = {
                  AgentIds:this.agentTreeDataS,
                  UserKey:this.UserKey,
                  BeginDate:this.withdrawalDetailvalueobj.BeginDate,
                  EndDate:this.withdrawalDetailvalueobj.EndDate,
                  MoneyTransType:this.withdrawalDetailvalueobj.MoneyTransType,
                  State:this.withdrawalDetailvalueobj.State,
                }
              }
              this.$loginapi.post(url, postData, response => {
                if (response.Ret == 0) {
                    $('.messageinfo').html(response.Msg);
                    $(".del-mask").fadeIn("fast");
                } else {
                  this.$message.error(response.Msg);
                }
              });
        },
        closeDelMask1() {

          $(".del-mask").fadeOut("fast");
          this.$router.push('/selects/exportdown');

        },
        closeDelMask() {

          $(".del-mask").fadeOut("fast");
        },

        gotodownroute(){

            this.$router.push('/selects/exportdown')
        }

  }
};
</script>

<style lang="less" scoped>
.trees {
  width: 195px;
  // background-color: rgba(0, 0, 0, 0.15);
  height: 100%;
  float: left;
  border-right: 1px solid rgba(0, 0, 0, 0.15);
  // .el-input {
  //   background-color: rgba(0, 0, 0, 0.15);
  // }
  // .el-tree {
  //   background-color: rgba(0, 0, 0, 0.15);
  // }
  .el-tree {
    height: calc(100% - 120px);
    overflow-x: scroll;
  }
}
.radios {
  padding: 0px 15px 0px;
}
.title_cc {
  height: 38px;
  line-height: 38px;
  font-size: 16px;
}
.derive{
    position: absolute;
    right: 15px;
    top: 10px;
    z-index: 9999999999;
}
</style>



// WEBPACK FOOTER //
// src/components/selects/todayreports.vue